<template>
  <div
    ref="kt_modal_emitente_restricoes_padrao_editar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_emitente_restricoes_padrao_editar"
  >
    <div
      class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Editar Restrição
          </h3>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="modalEditarEmitenteRestricaoPadrao(false)"
          >
            <span class="svg-icon svg-icon-2x">
              <img src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-0">
          <div class="post d-flex flex-column-fluid pt-7 bg-lighten">
            <div class="container-xxl p-0" ref="errosGerais">
              <div
                v-if="loading"
                class="ms-7 mb-7"
                v-bind:data-kt-indicator="loading ? 'on' : 'off'"
              >
                <span class="indicator-progress">
                  Aguarde, carregando...
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-2"
                  ></span>
                </span>
              </div>
              <div
                v-if="this.errosGerais.Message"
                class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-7 me-7 mb-9 p-6"
              >
                <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                  <inline-svg src="media/icons/duotune/general/gen044.svg" />
                </span>
                <div class="d-flex flex-stack flex-grow-1">
                  <div class="fw-bold">
                    <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                    <div class="fs-6 text-gray-600">
                      {{ this.errosGerais.Message }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="!loading" class="d-flex flex-column flex-lg-row px-7">
                <div
                  class="d-flex flex-column flex-row-fluid gap-6 mb-7 gap-lg-10"
                >
                  <div class="d-flex flex-column gap-7 gap-lg-10">
                    <div class="card card-flush py-4">
                      <div class="card-header">
                        <div class="card-title">
                          <h2>Geral</h2>
                        </div>
                      </div>
                      <div class="card-body pt-0">
                        <div class="mb-5 fv-row">
                          <label class="required form-label"
                            >Descrição do módulo</label
                          >
                          <input
                            type="text"
                            class="form-control mb-2"
                            placeholder="Descrição do módulo"
                            maxlength="40"
                            v-model="emitenteRestricaoPadrao.modulo"
                          />
                          <div class="row">
                            <div class="col-6 pe-0">
                              <div
                                class="fv-plugins-message-container invalid-feedback m-0"
                              >
                                {{ errosValidacao["modulo"] }}
                              </div>
                            </div>
                            <div class="col-6 ps-2">
                              <div class="text-end text-muted fs-7">
                                {{ emitenteRestricaoPadrao.modulo.length }}/40
                                caracteres
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mb-10 fv-row">
                          <label class="required form-label"
                            >Descrição da restrição</label
                          >
                          <input
                            type="text"
                            class="form-control mb-2"
                            placeholder="Descrição da restrição"
                            maxlength="75"
                            v-model="emitenteRestricaoPadrao.descricao"
                          />
                          <div class="row">
                            <div class="col-6 pe-0">
                              <div
                                class="fv-plugins-message-container invalid-feedback m-0"
                              >
                                {{ errosValidacao["descricao"] }}
                              </div>
                            </div>
                            <div class="col-6 ps-2">
                              <div class="text-end text-muted fs-7">
                                {{
                                  emitenteRestricaoPadrao.descricao.length
                                }}/75 caracteres
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer d-flex justify-content-end py-6 px-9">
                <button
                  class="btn btn-danger svg-icon-white me-2 mb-2"
                  data-bs-dismiss="modal"
                  @click="modalEditarEmitenteRestricaoPadrao(false)"
                >
                  <span class="svg-icon svg-icon-1">
                    <inline-svg
                      src="media/icons/duotune/arrows/arr015.svg"
                      class="me-2"
                    />Cancelar
                  </span>
                </button>
                <button
                  class="btn btn-success svg-icon-white mb-2"
                  @click="confirmarEmitenteRestricaoPadrao()"
                  v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
                >
                  <span class="indicator-progress">
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-1"
                    ></span>
                    Aguarde...
                  </span>
                  <span class="svg-icon svg-icon-1" v-if="!this.loading">
                    <inline-svg
                      src="media/icons/duotune/arrows/arr016.svg"
                      class="me-2"
                    />Confirmar
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hideModal, getOrCreateInstanceModal } from "@/core/helpers/dom";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  emits: [
    "exibirModalEmitenteRestricaoPadrao",
    "atualizarEmitenteRestricaoPadrao",
  ],
  props: {
    idEmitenteRestricaoPadrao: { type: Number, required: true },
  },
  methods: {
    modalEditarEmitenteRestricaoPadrao(exibir) {
      if (exibir === false) {
        this.$emit("exibirModalEmitenteRestricaoPadrao", false);
      }
    },
    async confirmarEmitenteRestricaoPadrao() {
      this.errosGerais = {};
      this.errosValidacao = [];
      this.loading = true;

      try {
        var retPut = await this.$store.dispatch(
          "emitenteRestricaoPadrao/putEmitenteRestricaoPadrao",
          this.emitenteRestricaoPadrao
        );
        if (retPut.Success === true) {
          toast.success("Restrição atualizada com sucesso!", { timeout: 3000 });
          this.$emit("atualizarEmitenteRestricaoPadrao");
          this.modalEditarEmitenteRestricaoPadrao(false);
          hideModal(this.$refs.kt_modal_emitente_restricoes_padrao_editar);
        }
      } catch (error) {
        this.errosGerais = error;
        this.errosValidacao = error;
        this.scroll("errosGerais");
      }
      this.loading = false;
    },
    scroll(refName) {
      let el = this.$refs[refName];
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    },
    async carregarEmitenteRestricaoPadrao() {
      this.errosGerais = {};
      this.errosValidacao = [];
      try {
        var ret = await this.$store.dispatch(
          "emitenteRestricaoPadrao/getEmitenteRestricaoPadrao",
          this.idEmitenteRestricaoPadrao
        );
        if (ret.Data !== null) {
          this.emitenteRestricaoPadrao = ret.Data;
        } else {
          this.errosGerais = ret;
        }
      } catch (error) {
        this.errosGerais = error;
      }
      if (this.errosGerais.Message) {
        this.scroll("errosGerais");
      }
      this.loading = false;
    },
    async asyncData() {
      this.loading = true;
      await this.carregarEmitenteRestricaoPadrao();
    },
  },
  mounted() {
    this.asyncData();
  },
  data() {
    return {
      loading: false,
      errosGerais: {},
      errosValidacao: [],
      emitenteRestricaoPadrao: {
        id: 0,
        permissao: "",
        regra: "",
        descricao: "",
        modulo: "",
      },
    };
  },
};
</script>

<style></style>
